"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("custom-event-polyfill");
require("./Shared/Polyfills/Element.matches");
var factory_1 = require("./Easydropdown/factory");
exports.default = factory_1.default;
//# sourceMappingURL=index.js.map